import type { DudaDateGranularity } from './dudaApi';

/** Legacy localStorage key — migrated into SQLite on first open. */
export const DUDA_ANALYTICS_STORAGE_KEY = 'growthHub_duda_analytics_v1';

/** One site’s raw API payloads (all documented metric families). */
export type DudaSiteAnalyticsSnapshot = {
  siteName: string;
  downloadedAt: string;
  range: { from: string; to: string };
  dateGranularity: DudaDateGranularity;
  trafficSummary: unknown | null;
  trafficSummaryError?: string;
  trafficByGeo: unknown | null;
  trafficByGeoError?: string;
  trafficBySystem: unknown | null;
  trafficBySystemError?: string;
  activities: unknown | null;
  activitiesError?: string;
};

export type DudaAnalyticsCacheV1 = {
  version: 1;
  downloadedAt: string;
  range: { from: string; to: string };
  dateGranularity: DudaDateGranularity;
  sites: Record<string, DudaSiteAnalyticsSnapshot>;
};
